import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class LayoutPrincipalService {
    public mensagensCarregamento = new BehaviorSubject<string[]>([]);

    definaMensagensCarregamento(mensagensCarregamento: string[]) {
        this.mensagensCarregamento.next(mensagensCarregamento);
    }
}